import React from 'react';

import Routes from './routes';
import ThemeProvider from './contexts/ThemeContext';
import './styles/index.css';
import { AxiosInterceptor } from './common/axiosInstance';

function App() {
  return (
    <ThemeProvider>
      <AxiosInterceptor>
        <Routes />
      </AxiosInterceptor>
    </ThemeProvider>
  );
}

export default App;
